import { NotificationTextMessage } from '@/core/enums/notification';
import { notifyError } from '@/core/notify/notify';

/** Angular `FormValidationService.validateForm`: returns true when valid, otherwise toasts the mandatory-fields error. */
export function validateForm(isValid: boolean): boolean {
  if (isValid) {
    return true;
  }
  notifyError(NotificationTextMessage.validationMessage);
  return false;
}
